var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFailure = function SvgFailure(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 4.995c7.182 0 13.005 5.823 13.005 13.005S25.182 31.005 18 31.005 4.995 25.182 4.995 18 10.818 4.995 18 4.995M18 0C8.059 0 0 8.059 0 18s8.059 18 18 18 18-8.059 18-18A18 18 0 0 0 18 0z",
    fill: "#ED7760",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 2.98c-8.277 0-14.986 6.71-14.986 14.987 0 8.276 6.71 14.986 14.986 14.986 8.277 0 14.986-6.71 14.986-14.986C32.986 9.69 26.276 2.98 18 2.98z",
    fill: "#ED7760",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.577 22.527c.316-.315.455-.676.417-1.081-.038-.405-.214-.766-.53-1.081L20.098 18l2.366-2.365c.316-.315.492-.676.53-1.08.038-.406-.101-.767-.417-1.082A1.552 1.552 0 0 0 21.44 13c-.443 0-.822.158-1.138.473l-2.366 2.342-2.298-2.297c-.316-.3-.677-.47-1.082-.507-.406-.037-.766.094-1.082.394a1.563 1.563 0 0 0-.473 1.15c0 .45.158.832.473 1.148L15.772 18l-2.299 2.297A1.55 1.55 0 0 0 13 21.435c0 .443.158.822.473 1.137.316.315.676.454 1.082.417.405-.038.766-.214 1.082-.53l2.298-2.297 2.366 2.365c.316.315.695.473 1.138.473.443 0 .823-.158 1.138-.473z",
    fill: "#FFF"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFailure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/failure.16c421b52be6695b020c5facbdea2df8.svg";